import { appConfig } from '../config/app-config';

const AUTH_TOKEN_KEY = 'dashboard_auth_token';
const AUTH_USER_KEY = 'dashboard_auth_user';

export const authService = {
  // Check if authentication is enabled
  isAuthEnabled(): boolean {
    return appConfig.auth.enabled;
  },

  // Validate username and password
  validateCredentials(username: string, password: string): boolean {
    const { usernames, passwords } = appConfig.auth;
    
    // Find matching username
    const userIndex = usernames.findIndex(user => user === username);
    
    // Check if username exists and password matches at same index
    if (userIndex !== -1 && passwords[userIndex] === password) {
      return true;
    }
    
    return false;
  },

  // Login user
  login(username: string, password: string): boolean {
    if (this.validateCredentials(username, password)) {
      // Generate simple token (just timestamp + username for basic security)
      const token = btoa(`${username}:${Date.now()}`);
      
      // Store in localStorage
      localStorage.setItem(AUTH_TOKEN_KEY, token);
      localStorage.setItem(AUTH_USER_KEY, username);
      
      return true;
    }
    
    return false;
  },

  // Logout user
  logout(): void {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_USER_KEY);
  },

  // Check if user is currently authenticated
  isAuthenticated(): boolean {
    if (!this.isAuthEnabled()) {
      return true; // If auth is disabled, always return true
    }
    
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const user = localStorage.getItem(AUTH_USER_KEY);
    
    return !!(token && user);
  },

  // Get current authenticated user
  getCurrentUser(): string | null {
    return localStorage.getItem(AUTH_USER_KEY);
  },

  // Check if token is expired (optional - for future enhancement)
  isTokenExpired(): boolean {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    
    if (!token) return true;
    
    try {
      const decoded = atob(token);
      const [, timestamp] = decoded.split(':');
      const tokenTime = parseInt(timestamp);
      const now = Date.now();
      
      // Token expires after 24 hours (86400000 ms)
      return (now - tokenTime) > 86400000;
    } catch {
      return true;
    }
  }
}; 